<template lang="pug">
modal-vue(
  :visible.sync="isVisible",
  modal_id="home_advertising_modal"
  :content_loaded="true"
  class="modalCampaign",
  size_modal="modal-lg"
)
  template(v-slot:header)
    div.modalCampaign__header.w-100.d-flex.flex-row.align-items-center.justify-content-between
      slot(name="header")
      button.btn.btn-sm.btn-close(
        type="button"
        @click="hide"
        data-cy="close_button"
        style=""
      )
        | ×
  template(v-slot:body)
    div.modalCampaign__body.w-100
      slot(name="content")
  template(v-slot:footer)
    .d-flex.justify-content-between.align-items-center.w-100
      .form-check.ml-3
        input.form-check-input(
          type="checkbox"
          v-model="notShowAgain"
          @change="setNotShowAgain"
          data-cy="not_show_again_checkbox"
        )
        label.form-check-label
          | {{ t('home_advertising.not_show_again') }}
      button.btn.btn-primary(
        type="button"
        @click="hide"
        data-cy="close_button"
      )
        | {{ t('cerrar') }}
</template>

<script>
import ModalVue from './Modal'
import mixins from 'common/mixins'

export default {
  name: 'home-advertising-vue',
  mixins: [mixins.translate],
  components: { ModalVue },
  props: {
    campaign: { type: String, default: '' }
  },
  data() {
    return {
      isVisible: false,
      notShowAgain: false,
      cookieData: {}
    }
  },
  methods: {
    hide() {
      this.isVisible = false
    },
    show() {
      this.isVisible = true
    },
    manageCampaign() {
      if (this.cookieData[this.campaign])
        return

      this.readCookie()
      if (!this.cookieData[this.campaign]) {
        this.show()
      }
    },
    readCookie() {
      var cookie = document.cookie.match(new RegExp('home_advertising=([^;]*)(;|$)'))
      if (cookie && cookie.length > 1)
        this.cookieData = JSON.parse(cookie[1])
      else
        this.cookieData = {}
    },
    setNotShowAgain() {
      this.cookieData[this.campaign] = this.notShowAgain
      this.saveCookie()
    },
    saveCookie() {
      document.cookie = `home_advertising=${JSON.stringify(this.cookieData)}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Lax;`
    }
  },
  created() {
    document.addEventListener('tolweb:cookieconsent:personalization:accepted', () => {
      this.manageCampaign()
    })
    if (window.cookieconsent && window.cookieconsent.get_allowed().includes('personalization')) {
      this.manageCampaign()
    }
  }
}
</script>
